/**
 * KAN-1003: публичная страница /terms (Пользовательское соглашение).
 */
import { LegalPageShell } from '@/components/legal/LegalPageShell';
import { LegalDocumentView } from '@/components/legal/LegalText';
import { TERMS_DOCUMENT } from '@/content/legal/terms';

export function TermsPage() {
  return (
    <LegalPageShell documentTitle={TERMS_DOCUMENT.title}>
      <LegalDocumentView document={TERMS_DOCUMENT} />
    </LegalPageShell>
  );
}

export default TermsPage;
